import React from 'react';
import { Container, Box } from '@mui/material';
import EmailTemplateManager from '../../components/admin/EmailTemplateManager';

const EmailTemplates: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box py={3}>
        <EmailTemplateManager />
      </Box>
    </Container>
  );
};

export default EmailTemplates;
